"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = void 0;
const helpers_1 = require("@/app/shared/helpers");
const DEFAULT_CALENDAR_SHOW_WEEKENDS = false;
exports.Settings = new (class {
    shouldCalendarShowWeekends() {
        const val = helpers_1.Storage.Local.getBoolean(helpers_1.Storage.Key.SETTINGS_CALENDAR_SHOW_WEEKENDS);
        return val === undefined ? DEFAULT_CALENDAR_SHOW_WEEKENDS : val;
    }
    setCalendarShowWeekends(value) {
        helpers_1.Storage.Local.setBoolean(helpers_1.Storage.Key.SETTINGS_CALENDAR_SHOW_WEEKENDS, value);
    }
})();
